import charmLip from "../img/products/CharmLip.webp";
import ganchosPurple from "../img/products/ganchosPurple.webp";
import peineCharmBlue from "../img/products/PeineCharmBlue.webp";
import peineCharmLip from "../img/products/PeineCharmLip.webp";
import photoCardholder from "../img/products/PhotoCardholder.webp";
import customPhotoCard from "../img/products/CustomPhotoCard.webp";
import PinkHairClip from "../img/products/PinkHairClip.webp";
import PinkHairClipWithLip from "../img/products/PinkHairClipWithLip.webp";
import Octopus from "../img/products/Octopus.webp";
import BlueOctopus from "../img/products/BlueOctopus.webp";
import PurpleOctopus from "../img/products/PurpleOctopus.webp";
import GreenOctopus from "../img/products/GreenOctopus.webp";

export const products = [
  {
    name: "Lip Charm Holder",
    category: "Accessories",
    startingPrice: "$20.00",
    description:
      "A cute lip charm holder made for bags, keys, or daily essentials.",
    images: [
      {
        src: charmLip,
        alt: "Lip Charm Holder",
        label: "Main Design",
      },
    ],
    variants: [
      {
        name: "Standard",
        price: "$20.00",
        description: "A cute charm holder for your lip gloss, keys, or bag.",
        imageIndex: 0,
      },
    ],
  },
  {
    name: "Hair Clip Set",
    category: "Hair Accessories",
    startingPrice: "$15.00",
    description:
      "Cute hair clip sets with soft colors and dreamy details. Available in different styles and gift-ready options.",
    images: [
      {
        src: ganchosPurple,
        alt: "Dreamy Purple Hair Clips",
        label: "Dreamy Purple",
      },
      {
        src: PinkHairClip,
        alt: "Soft Pink Hair Clips",
        label: "Soft Pink",
      },
      {
        src: PinkHairClipWithLip,
        alt: "Pink Hair Clip Gift Set with Lip Gloss",
        label: "Pink Gift Set",
      },
    ],
    variants: [
      {
        name: "Dreamy Purple Clips",
        price: "$15.00",
        description: "A cute purple hair clip set with soft decorative details.",
        imageIndex: 0,
      },
      {
        name: "Soft Pink Clips",
        price: "$15.00",
        description: "A sweet pink hair clip set with a delicate handmade look.",
        imageIndex: 1,
      },
      {
        name: "Pink Gift Set",
        price: "From $20.00",
        description:
          "A gift-ready set with pink hair clips and a matching lip gloss detail.",
        imageIndex: 2,
      },
      {
        name: "Custom Color Set",
        price: "From $18.00",
        description:
          "Choose your preferred color style depending on available designs.",
        imageIndex: 1,
      },
    ],
  },
  {
    name: "Charm Comb",
    category: "3D Printed Accessories",
    startingPrice: "$27.00",
    description:
      "A pocket-size comb with cute charm details. Small, practical, and perfect for bags or purses.",
    images: [
      {
        src: peineCharmBlue,
        alt: "Blue Charm Comb",
        label: "Blue Charm",
      },
      {
        src: peineCharmLip,
        alt: "Lip Charm Comb",
        label: "Lip Charm",
      },
    ],
    variants: [
      {
        name: "Blue Charm",
        price: "$27.00",
        description: "A pocket comb with a soft blue charm detail.",
        imageIndex: 0,
      },
      {
        name: "Lip Charm",
        price: "$30.00",
        description: "A pocket comb with a cute lip charm detail.",
        imageIndex: 1,
      },
    ],
  },
  {
    name: "Photo Card Holder",
    category: "Decorative Accessories",
    startingPrice: "$10.00",
    description:
      "A cute photo card holder for displaying pictures, cards, or small memories.",
    images: [
      {
        src: photoCardholder,
        alt: "Photo Card Holder",
        label: "Standard",
      },
    ],
    variants: [
      {
        name: "Standard",
        price: "$10.00",
        description: "A cute holder for your favorite pictures or cards.",
        imageIndex: 0,
      },
    ],
  },
  {
    name: "Custom Photo Card",
    category: "Decorative Accessories",
    startingPrice: "$3.00",
    description:
      "Turn your favorite moments into memories you can touch. Design your custom photo cards and keep the moments that make you smile close to your heart.",
    images: [
      {
        src: customPhotoCard,
        alt: "Custom Photo Card",
        label: "Custom Design",
      },
    ],
    variants: [
      {
        name: "Single Card",
        price: "$3.00",
        description: "One custom photo card made with your favorite picture.",
        imageIndex: 0,
      },
      {
        name: "Mini Pack",
        price: "From $10.00",
        description: "Multiple custom cards depending on quantity.",
        imageIndex: 0,
      },
    ],
  },
  {
    name: "Flexi Octopus",
    category: "3D Printed Accessories",
    startingPrice: "$25.00",
    description:
      "A flexible octopus with a cute movable design. Available in different colors and finishes, perfect as a desk buddy, gift, or collectible piece.",
    images: [
    
      {
        src: PurpleOctopus,
        alt: "Dreamy Purple Flexi Octopus",
        label: "Dreamy Purple",
      },
      {
        src: BlueOctopus,
        alt: "Ocean Blue Flexi Octopus",
        label: "Ocean Blue",
      },
      {
        src: GreenOctopus,
        alt: "Mint Lagoon Flexi Octopus",
        label: "Mint Lagoon",
      },
      
      {
        src: Octopus,
        alt: "Mermaid Galaxy Flexi Octopus",
        label: "Mermaid Galaxy",
      },
    ],
    variants: [
   
      {
        name: "Dreamy Purple",
        price: "$25.00",
        description: "A cute purple finish with a sweet and magical style.",
        imageIndex: 1,
      },
      {
        name: "Ocean Blue",
        price: "$30.00",
        description: "A soft blue octopus with a clean and playful look.",
        imageIndex: 0,
      },
      {
        name: "Mint Lagoon",
        price: "$25.00",
        description: "A fresh green shade inspired by soft ocean tones.",
        imageIndex: 2,
      },
      {
        name: "Mermaid Galaxy",
        price: "$40.00",
        description:
          "A shiny color-shift finish with purple, green, and blue tones.",
        imageIndex: 3,
      },
    ],
  },
];